import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import { Stack, Typography } from '@mui/material';
import { CountryBadge } from 'framework/form';
import { EMPTY_VALUE_INDICATOR, getWithThousandsSeparator } from 'framework/utils';
import type { SalaryRange } from '../../types';

const SalaryRanges = ({ ranges }: { ranges: SalaryRange[] }) => (
  <Stack gap={1}>
    {ranges.map(range => (
      <Stack key={range.officeId} direction="row" alignItems="center" gap={4}>
        <Stack direction="row" alignItems="center" gap={1} minWidth={180}>
          <CountryBadge country={range.country} sx={{ p: 0 }} />
          <Typography variant="body1">
            {range.country}, {range.currency}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" gap={0.5} minWidth={80}>
          <ArrowDownwardOutlinedIcon fontSize="small" color="action" />
          <Typography variant="body1">
            {range.minValue ? getWithThousandsSeparator(range.minValue) : EMPTY_VALUE_INDICATOR}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" gap={0.5} minWidth={80}>
          <ArrowUpwardOutlinedIcon fontSize="small" color="action" />
          <Typography variant="body1">
            {range.maxValue ? getWithThousandsSeparator(range.maxValue) : EMPTY_VALUE_INDICATOR}
          </Typography>
        </Stack>
      </Stack>
    ))}
  </Stack>
);

export default SalaryRanges;
